import React from "react";
import { Link } from "react-router-dom";
import "./Legal.css";

// Shared shell for the legal pages. `Ph` marks entity details that still need
// filling in — amber-highlighted so an unfilled value cannot ship unnoticed.
export const Ph = ({ children }) => <span className="legal-ph">{children}</span>;

export default function LegalPage({ title, updated, children }) {
  React.useEffect(() => {
    document.title = `${title} — Feis.link`;
    window.scrollTo(0, 0);
    return () => { document.title = "Feis.link"; };
  }, [title]);

  return (
    <div className="legal-page">
      <div className="legal-wrap">
        <Link className="legal-toplink" to="/">← Feis.link</Link>
        <h1>{title}</h1>
        <p className="legal-updated">Last updated: {updated}</p>
        {children}
      </div>
    </div>
  );
}
